export default __webpack_public_path__ + "static/media/carreful.8ee4c757.svg";